<template>
  <v-list-item
    :class="{ 'sidebar-active': languageArticle.language_id === article.language_id }"
    :to="languageArticle.id ? { name: 'news-articles.manage', params: { id: languageArticle.id } } : null"
    :title="languageArticle.id ? 'Edit Article' : null"
    color="grey"
    class="d-flex align-center pl-4 pr-2"
  >
    <flag-pip :flag="languageArticle.flag" :text="languageArticle.languageName" :show-tooltip="true" />
    <published-chip
      :value="languageArticle.wp_publish_status"
      :show-text="false"
      :show-tooltip="true"
      class="ml-2"
      small
    />
    <v-btn
      v-if="!languageArticle.id && !article.parent.auto_translate"
      color="primary"
      class="ml-2"
      small
      depressed
      :disabled="!canTranslate"
      :loading="isLoading"
      @click="translate"
    >
      <span>Translate</span>
    </v-btn>
    <base-chip
      v-if="languageArticle.disabled"
      :text="languageArticle.siteName"
      :title="languageArticle.siteName"
      color="grey darken-2"
      dark
      class="mt-0 ml-2"
      small
    />
    <span v-if="!languageArticle.id && article.parent.auto_translate" class="grey--text text-caption ml-2">
      Awaiting to publish
    </span>
    <v-spacer />
    <v-btn
      v-if="languageArticle.wp_permalink"
      color="ml-2 secondary"
      title="Preview page in new tab"
      depressed
      small
      @click.prevent="$emit('permalink', languageArticle.wp_permalink)"
    >
      <v-icon small>launch</v-icon>
    </v-btn>
  </v-list-item>
</template>

<script>
import FlagPip from '@/views/news-articles/components/flag-pip'
import PublishedChip from '@/views/news-articles/components/published-chip'
import BaseChip from '@/components/chips/base-chip'

export default {
  components: { FlagPip, PublishedChip, BaseChip },
  props: {
    article: {
      type: Object,
      required: true,
    },
    languageArticle: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    canTranslate() {
      if (this.isLoading) return false
      if (this.article.language.code !== 'en') return false
      if (!this.article.wp_post_id) return false
      if (this.article.wp_publish_status !== 'publish') return false
      return !this.languageArticle.id
    },
  },
  methods: {
    async translate() {
      this.isLoading = true
      try {
        const { news_article_id } = this.article
        const { language_id, site_id } = this.languageArticle
        await this.$emit('translate', [{ language_id, site_id, news_article_id }])
        this.$notify({ type: 'success', text: 'Successfully translated news article.' })
        this.isLoading = false
      } catch (e) {
        this.$notify({ type: 'error', text: 'Unable to translate news article.' })
        this.isLoading = false
      }
    },
  },
}
</script>
